import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class Collapse extends kr.Component {
    init() {
        this._items = this.$element.querySelectorAll('.js-collapse--item');
        this._bind();
    }

    _bind() {
        this.on('click', '.js-collapse--toggle', (target, event) => {
            event.preventDefault();
            const parent = target.parentNode;
            if (HTMLClass.hasClass(parent, 'js-collapse--item--opened')) {
                this._close(parent);
                return;
            }
            this._closeAll();
            this._open(parent);
        });
    }

    _open(el) {
        const content = el.querySelector('.js-collapse--content');
      
        content.style.display = 'block';
        setTimeout(() => {
            HTMLClass.addClass(el, 'js-collapse--item--opened');
        }, 1);
    }
    _close(el) {
        HTMLClass.removeClass(el, 'js-collapse--item--opened');
        const content = el.querySelector('.js-collapse--content');
        content.style.display = 'none';
    }

    _closeAll() {
        for (let item of this._items) {
            this._close(item);
        }
    }
}

kr.registerComponent('.js-collapse', {
    component: Collapse
});